import React from "react";
import {connect} from "react-redux";
import moment from "moment";

//action imports
import {Spinner} from "../common/Spinner";

//component imports
import Announcements from "../announcements/Announcements";

class Home extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            clientUsers: this.props.clientUsers,
            clientUsersLoading: this.props.clientUsersLoading,
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (nextProps !== this.props) {
            this.setState({
                clientUsers: nextProps.clientUsers,
                clientUsersLoading: nextProps.clientUsersLoading,
            })
        }
    }

    renderClientUsers() {
        //extract state
        const { clientUsers, clientUsersLoading } = this.state;

        let clientUsersValue = 0;
        if (clientUsers.length !== 0) {
            clientUsersValue = clientUsers.length;
        }

        if (clientUsersLoading) {
            return <Spinner/>
        } else {
            return(
                <div>
                    {clientUsersValue}
                </div>
            );
        }
    }

    render() {
        return(
            <div>
                <h1 id={"headerTitle"}>Dashboard</h1>
                {/*<div className={"homeBoxContainer"}>*/}
                {/*    <div className={"totalNPLBox"}>*/}
                {/*        <h2>Up-coming Activities</h2>*/}
                {/*        {this.renderUpcomingActivities()}*/}
                {/*    </div>*/}
                {/*    <div className={"totalNPLBox"}>*/}
                {/*        <h2>Users</h2>*/}
                {/*        {this.renderClientUsers()}*/}
                {/*    </div>*/}
                {/*</div>*/}

                <Announcements/>
            </div>
        );
    }
}

const mapStateToProps = state => {
    const { clientUsers, clientUsersLoading } = state.app;
    const { services, servicesLoading } = state.services;
    return {
        clientUsers,
        clientUsersLoading,
        services,
        servicesLoading
    }
}

export default connect(mapStateToProps, { })(Home);